export const PLAYBACK_LOCK_KEY = 'xstudi_active_playback';

function newTabId() {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

/**
 * One playing video per browser: the newest playback wins.
 *
 * A tab that starts playing writes {tabId, at} under PLAYBACK_LOCK_KEY. The
 * browser fires `storage` in every OTHER tab of the origin (never in the
 * writer), and a tab that sees another tab's claim is told to stop. `at`
 * makes every claim a new value: an identical setItem fires no event.
 *
 * Other devices are not this module's job: they hold a different token and
 * the websocket force-logout signs the older device out (App.vue).
 *
 * @param {{storage?: Storage, target?: EventTarget, onTakenOver: function(): void}} options
 * @return {{tabId: string, claim: function(): void, destroy: function(): void}}
 */
export function createPlaybackLock({ storage = window.localStorage, target = window, onTakenOver }) {
  const tabId = newTabId();

  function onStorage(event) {
    if (event.key !== PLAYBACK_LOCK_KEY || !event.newValue) return;
    let claim;
    try {
      claim = JSON.parse(event.newValue);
    } catch (e) {
      return;
    }
    if (claim && claim.tabId !== tabId) {
      onTakenOver();
    }
  }

  target.addEventListener('storage', onStorage);

  return {
    tabId,
    claim() {
      try {
        storage.setItem(PLAYBACK_LOCK_KEY, JSON.stringify({ tabId, at: Date.now() }));
      } catch (e) {
        // Storage full or blocked: the lock is best-effort and must never
        // stop the video from playing.
      }
    },
    destroy() {
      target.removeEventListener('storage', onStorage);
    },
  };
}
